<div class="panel" *ngIf="!hideInfo">
    <div class="k-d-flex k-justify-content-between k-align-items-center k-pt-1 k-pl-3 k-pr-3">
        <div class="header">
            {{title}}
        </div>
        <button kendoButton fillMode="flat" [svgIcon]="svgX" (click)="hideInfo = true" class="close" aria-label="Dismiss">
        </button>
    </div>
    <div class="k-d-flex k-justify-content-between k-p-3 k-pr-8 content">
        {{content}}
    </div>
</div>